module.exports = __webpack_public_path__ + "assets/img/filtrate-icon-1.cb87aaa3.png";